<template>
  <section class="section container">
    <h1 class="title is-4 is-pulled-right mb-0">
      {{ $t("access module configuration") }}
    </h1>

    <div class="field mt-5">
      <div class="control">
        <button class="button is-rounded is-primary" @click="save">
          <span class="icon"><i class="fa fa-save"></i></span>
          <span>{{ $t("save") }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
} from "@/utils";
import { isEmpty } from "lodash";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "AccessSettings",
  components: { GenericDropdown },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      v.$root.loader(true);
      save_configuration(this, v.meta)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        // console.log("conf", conf);
        if (!isEmpty(conf)) {
          v.meta = conf;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
